<template>
  <div class="page-source common-wrap">
    <div class="type-item">
      <div class="type-title">
        最新优秀模型推荐
        <router-link to="/model" class="more">更多模型 <i class="el-icon-d-arrow-right"></i></router-link>
      </div>
      <div class="paeparation-result item-one clearfix">
        <div class="work-card-one">
          <router-link to="" class="img-f">
            <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
          </router-link>
          <div class="card-infoes has-price">
            <div class="price">￥50</div>
            <router-link to="" class="card-tit over-ellipsis">作品名称作品名称作品名称作品名称作品名称</router-link>
            <div class="type-seemuch clearfix">
              <div class="type">.max</div>
              <div class="see-much clearfix">
                <i class="icon"></i>
                <span class="much">55</span>
              </div>
            </div>
          </div>
          <div class="auther">
            <router-link to="/home" class="avatar-f">
              <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
            </router-link>
            <router-link to="/home" class="user-name over-ellipsis">人人动画人人动画人人动画</router-link>
            <div class="date">1天前</div>
          </div>
        </div>
        <div class="work-card-one">
          <router-link to="" class="img-f">
            <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
          </router-link>
          <div class="card-infoes has-price">
            <div class="price">￥50</div>
            <router-link to="" class="card-tit over-ellipsis">作品名称作品名称作品名称作品名称作品名称</router-link>
            <div class="type-seemuch clearfix">
              <div class="type">.max</div>
              <div class="see-much clearfix">
                <i class="icon"></i>
                <span class="much">55</span>
              </div>
            </div>
          </div>
          <div class="auther">
            <router-link to="/home" class="avatar-f">
              <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
            </router-link>
            <router-link to="/home" class="user-name over-ellipsis">人人动画人人动画人人动画</router-link>
            <div class="date">1天前</div>
          </div>
        </div>
        <div class="work-card-one">
          <router-link to="" class="img-f">
            <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
          </router-link>
          <div class="card-infoes has-price">
            <div class="price">￥50</div>
            <router-link to="" class="card-tit over-ellipsis">作品名称作品名称作品名称作品名称作品名称</router-link>
            <div class="type-seemuch clearfix">
              <div class="type">.max</div>
              <div class="see-much clearfix">
                <i class="icon"></i>
                <span class="much">55</span>
              </div>
            </div>
          </div>
          <div class="auther">
            <router-link to="/home" class="avatar-f">
              <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
            </router-link>
            <router-link to="/home" class="user-name over-ellipsis">人人动画人人动画人人动画</router-link>
            <div class="date">1天前</div>
          </div>
        </div>
        <div class="work-card-one">
          <router-link to="" class="img-f">
            <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
          </router-link>
          <div class="card-infoes has-price">
            <div class="price">￥50</div>
            <router-link to="" class="card-tit over-ellipsis">作品名称作品名称作品名称作品名称作品名称</router-link>
            <div class="type-seemuch clearfix">
              <div class="type">.max</div>
              <div class="see-much clearfix">
                <i class="icon"></i>
                <span class="much">55</span>
              </div>
            </div>
          </div>
          <div class="auther">
            <router-link to="/home" class="avatar-f">
              <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
            </router-link>
            <router-link to="/home" class="user-name over-ellipsis">人人动画人人动画人人动画</router-link>
            <div class="date">1天前</div>
          </div>
        </div>
        <div class="work-card-one">
          <router-link to="" class="img-f">
            <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
          </router-link>
          <div class="card-infoes has-price">
            <div class="price">￥50</div>
            <router-link to="" class="card-tit over-ellipsis">作品名称作品名称作品名称作品名称作品名称</router-link>
            <div class="type-seemuch clearfix">
              <div class="type">.max</div>
              <div class="see-much clearfix">
                <i class="icon"></i>
                <span class="much">55</span>
              </div>
            </div>
          </div>
          <div class="auther">
            <router-link to="/home" class="avatar-f">
              <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
            </router-link>
            <router-link to="/home" class="user-name over-ellipsis">人人动画人人动画人人动画</router-link>
            <div class="date">1天前</div>
          </div>
        </div>
      </div>
    </div>
    <div class="type-item">
      <div class="type-title">
        最新优秀动作推荐
        <router-link to="/action" class="more">更多动作 <i class="el-icon-d-arrow-right"></i></router-link>
      </div>
      <div class="paeparation-result item-one clearfix">
        <div class="work-card-one">
          <router-link to="/action/detail" class="img-f">
            <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
          </router-link>
          <div class="card-infoes has-price">
            <div class="price">￥50</div>
            <router-link to="/action/detail" class="card-tit over-ellipsis">作品名称作品名称作品名称作品名称作品名称</router-link>
            <div class="type-seemuch clearfix">
              <div class="type">.max</div>
              <div class="see-much clearfix">
                <i class="icon"></i>
                <span class="much">55</span>
              </div>
            </div>
          </div>
          <div class="auther">
            <router-link to="/home" class="avatar-f">
              <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
            </router-link>
            <router-link to="/home" class="user-name over-ellipsis">人人动画人人动画人人动画</router-link>
            <div class="date">1天前</div>
          </div>
        </div>
        <div class="work-card-one">
          <router-link to="/action/detail" class="img-f">
            <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
          </router-link>
          <div class="card-infoes has-price">
            <div class="price">￥50</div>
            <router-link to="/action/detail" class="card-tit over-ellipsis">作品名称作品名称作品名称作品名称作品名称</router-link>
            <div class="type-seemuch clearfix">
              <div class="type">.max</div>
              <div class="see-much clearfix">
                <i class="icon"></i>
                <span class="much">55</span>
              </div>
            </div>
          </div>
          <div class="auther">
            <router-link to="/home" class="avatar-f">
              <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
            </router-link>
            <router-link to="/home" class="user-name over-ellipsis">人人动画人人动画人人动画</router-link>
            <div class="date">1天前</div>
          </div>
        </div>
        <div class="work-card-one">
          <router-link to="/action/detail" class="img-f">
            <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
          </router-link>
          <div class="card-infoes has-price">
            <div class="price">￥50</div>
            <router-link to="/action/detail" class="card-tit over-ellipsis">作品名称作品名称作品名称作品名称作品名称</router-link>
            <div class="type-seemuch clearfix">
              <div class="type">.max</div>
              <div class="see-much clearfix">
                <i class="icon"></i>
                <span class="much">55</span>
              </div>
            </div>
          </div>
          <div class="auther">
            <router-link to="/home" class="avatar-f">
              <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
            </router-link>
            <router-link to="/home" class="user-name over-ellipsis">人人动画人人动画人人动画</router-link>
            <div class="date">1天前</div>
          </div>
        </div>
        <div class="work-card-one">
          <router-link to="/action/detail" class="img-f">
            <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
          </router-link>
          <div class="card-infoes has-price">
            <div class="price">￥50</div>
            <router-link to="/action/detail" class="card-tit over-ellipsis">作品名称作品名称作品名称作品名称作品名称</router-link>
            <div class="type-seemuch clearfix">
              <div class="type">.max</div>
              <div class="see-much clearfix">
                <i class="icon"></i>
                <span class="much">55</span>
              </div>
            </div>
          </div>
          <div class="auther">
            <router-link to="/home" class="avatar-f">
              <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
            </router-link>
            <router-link to="/home" class="user-name over-ellipsis">人人动画人人动画人人动画</router-link>
            <div class="date">1天前</div>
          </div>
        </div>
        <div class="work-card-one">
          <router-link to="/action/detail" class="img-f">
            <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
          </router-link>
          <div class="card-infoes has-price">
            <div class="price">￥50</div>
            <router-link to="/action/detail" class="card-tit over-ellipsis">作品名称作品名称作品名称作品名称作品名称</router-link>
            <div class="type-seemuch clearfix">
              <div class="type">.max</div>
              <div class="see-much clearfix">
                <i class="icon"></i>
                <span class="much">55</span>
              </div>
            </div>
          </div>
          <div class="auther">
            <router-link to="/home" class="avatar-f">
              <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
            </router-link>
            <router-link to="/home" class="user-name over-ellipsis">人人动画人人动画人人动画</router-link>
            <div class="date">1天前</div>
          </div>
        </div>
      </div>
    </div>
    <div class="type-item">
      <div class="type-title">
        最新优秀音效推荐
        <router-link to="/audio" class="more">更多音效 <i class="el-icon-d-arrow-right"></i></router-link>
      </div>
      <div class="paeparation-result item-two clearfix">
        <router-link to="/audio/detail" class="audio-item-one clearfix">
          <img class="left-img" :src="require('@/assets/images/audio_img.png')" alt="">
          <div class="right-info">
            <div class="tit ell">音效名称音效名称音效名称</div>
            <div class="foss clearfix">
              <div class="geshi ell">格式：mp3</div>
              <div class="price">￥250</div>
            </div>
          </div>
        </router-link>
        <router-link to="/audio/detail" class="audio-item-one clearfix">
          <img class="left-img" :src="require('@/assets/images/audio_img.png')" alt="">
          <div class="right-info">
            <div class="tit ell">音效名称音效名称音效名称</div>
            <div class="foss clearfix">
              <div class="geshi ell">格式：mp3</div>
              <div class="price">￥250</div>
            </div>
          </div>
        </router-link>
        <router-link to="/audio/detail" class="audio-item-one clearfix">
          <img class="left-img" :src="require('@/assets/images/audio_img.png')" alt="">
          <div class="right-info">
            <div class="tit ell">音效名称音效名称音效名称</div>
            <div class="foss clearfix">
              <div class="geshi ell">格式：mp3</div>
              <div class="price">￥250</div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  components: {

  },
  data () {
    return {

    }
  }
}
</script>

<style scoped lang="less">
//@import "../../assets/less/stylePublic.less";
.page-source{
  padding-top: @NAVHEIGHT;
  .type-item{
    margin-bottom: 20px;
    background: #fff;
    .type-title{
      position: relative;
      padding: 20px 15px;
      font-size: 18px;
      font-weight: bold;
      color: #4d4d4d;
      .more{
        position: absolute;
        right: 10px;
        top: 20px;
        font-weight: normal;
        font-size: 14px;
        color: #727272;
      }
    }
    .paeparation-result{
      padding-bottom: 0;
      .work-card-one{
        margin-bottom: 0;
      }
    }
  }
}
@media screen and (min-width: 751px) {
  .paeparation-result{
    &.item-one{
      overflow: hidden;
      height: 300px;
    }
    &.item-two{
      overflow: hidden;
      height: 120px;
    }
  }
}
@media screen and (min-width: 1024px) {
  .page-source{
    padding-top: @NAVHEIGHT + 20px;
  }
  .paeparation-result{
    &.item-one{
      height: 255px;
    }
  }
}
</style>
